export const DESIGNING_HEADER_THEME_KEY = "designingHeaderTheme";

export type DesigningHeaderTheme = {
  headerBackground: string;
  menuColor: string;
  menuFontSizePx: number;
};

const DEFAULTS: DesigningHeaderTheme = {
  headerBackground: "#5b91e6",
  menuColor: "#e3e9ed",
  menuFontSizePx: 14,
};

const STYLE_ID = "designing-header-dynamic-theme";

function normalizeHex(input: string, fallback: string): string {
  const s = input.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(s)) return s;
  if (/^[0-9A-Fa-f]{6}$/.test(s)) return `#${s}`;
  return fallback;
}

export function loadDesigningHeaderTheme(): DesigningHeaderTheme {
  try {
    const raw = localStorage.getItem(DESIGNING_HEADER_THEME_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      headerBackground: normalizeHex(
        parsed.headerBackground ?? "",
        DEFAULTS.headerBackground
      ),
      menuColor: normalizeHex(parsed.menuColor ?? "", DEFAULTS.menuColor),
      menuFontSizePx:
        typeof parsed.menuFontSizePx === "number" &&
        parsed.menuFontSizePx >= 10 &&
        parsed.menuFontSizePx <= 28
          ? parsed.menuFontSizePx
          : DEFAULTS.menuFontSizePx,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

function buildThemeCss(theme: DesigningHeaderTheme): string {
  const { headerBackground, menuColor, menuFontSizePx } = theme;
  const fontPx = `${menuFontSizePx}px`;
  return `
#kt_header {
  background-color: ${headerBackground} !important;
}
#kt_header .menu-nav > .menu-item > .menu-link .menu-text {
  font-size: ${fontPx} !important;
}
#kt_header .menu-nav > .menu-item > .menu-link,
#kt_header .menu-nav > .menu-item > .menu-link .menu-text,
#kt_header .menu-nav > .menu-item > .menu-link .menu-icon,
#kt_header .menu-nav > .menu-item > .menu-link i {
  color: ${menuColor} !important;
}
#designing_footer {
  background-color: ${headerBackground} !important;
  color: ${menuColor} !important;
  font-size: ${fontPx} !important;
}
#designing_footer .designing-footer-item {
  color: ${menuColor} !important;
  font-size: ${fontPx} !important;
}
#designing_footer .designing-footer-label,
#designing_footer .designing-footer-value,
#designing_footer .designing-footer-divider {
  color: ${menuColor} !important;
}
`.trim();
}

/** Updates injected styles. Optionally skips writing localStorage (e.g. initial load). */
export function applyDesigningHeaderTheme(
  theme: DesigningHeaderTheme,
  persist: boolean = true
): void {
  if (persist) {
    localStorage.setItem(DESIGNING_HEADER_THEME_KEY, JSON.stringify(theme));
  }
  let el = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  if (!el) {
    el = document.createElement("style");
    el.id = STYLE_ID;
    document.head.appendChild(el);
  }
  el.textContent = buildThemeCss(theme);
}
